<template>
  <div :style="{
    fontSize: '9.6px',
  }">
    <img v-if="form?.email?.navLogoUrl" :src="form?.email?.navLogoUrl" alt="Logo" style="width: 100%; height: auto; max-width: 25%; max-height: 46px; margin: 0 auto; padding-bottom: 20px; display: block; object-fit: cover;" />

    <p :style="{
      marginBottom: '6px',
      fontWeight: 'bold',
      color: form?.email?.headingTextColor
    }">
      {{ form?.email?.introduction }}
    </p>

    <div :style="{
      lineHeight: '1.5',
      color: form?.email?.bodyTextColor,
      marginBottom: '19.2px',
    }">
      <p style="font-size: 6px;">{{ form.email.message }}</p>
      <div v-for="(section, sectionIndex) in sections" :key="sectionIndex">
        <div :style="{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          paddingBottom: '3.6px',
          marginTop: '9.6px',
          marginBottom: '4px',
          borderBottom: `1px solid ${form?.email?.lineDividerColor}`,
          alignItems: 'flex-end',
          flexDirection: 'row',
        }">
          <div style="width: 100%;">
            <p style="margin-bottom: 1px; font-weight: bold; font-size: 5.4px;">
              {{ section.name }}
            </p>
            <p style="font-size: 4.2px;">
              {{ section.direction }}
            </p>
          </div>
        </div>
        <div>
          <div style="font-size: 4.2px; margin-bottom: 6px;">
            <span v-for="(concern, key) in section.concerns" :key="key">
              {{ concern }}<span v-if="key < section.concerns.length - 2">, </span><span v-if="key === section.concerns.length - 2"> & </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div :style="{
      textAlign: 'center',
      fontSize: '4.2px',
      color: '#777777',
      marginTop: '12px',
      paddingTop: '14.4px',
      borderTop: `1px solid ${form?.email?.lineDividerColor}`,
    }">
      <p>&copy; {{ currentYear }} | {{ form.content.name }} | All rights reserved.</p>
      <p v-if="form?.content?.websiteLink">
        <a :href="form.content.websiteLink">{{ form.content.websiteLink }}</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';
const props = defineProps(['form', 'sections']);
const currentYear = ref(new Date().getFullYear());

</script>
